import { __decorate } from "tslib";
import Component from 'vue-class-component';
import ReactiveComponent from '../components/ReactiveComponent';
import Task from '@/services/task';
import TemplateContent from "@/components/template/TemplateContent.vue";
import VideoForm from "@/components/VideoForm.vue";
import { Prop } from "vue-property-decorator";
let VideoEdit = class VideoEdit extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.name = '';
        this.link = '';
        this.videoQuery = { videos: [] };
        this.videoTask = Task.idle();
        this.submitTask = Task.idle();
    }
    created() {
        const idNumber = Number(this.id);
        if (idNumber == null || Number.isNaN(idNumber)) {
            console.log('Invalid id prop');
            return;
        }
        this.subscribeQuery({
            tag: 'video',
            options: {
                query: require('@/apollo/queries/videoEdit.graphql'),
                variables: { id: idNumber }
            },
            onTask: task => {
                this.videoTask = task;
                if (task.isSuccessful) {
                    this.videoQuery = task.data;
                    this.name = this.videoQuery.videos[0].name;
                    this.link = this.videoQuery.videos[0].link;
                }
            }
        });
    }
    submit() {
        const videosListQuery = require('@/apollo/queries/videosList.graphql');
        this.subscribeMutation({
            tag: 'submit',
            options: {
                mutation: require('@/apollo/mutations/editVideo.graphql'),
                variables: {
                    id: this.videoQuery.videos[0].id,
                    name: this.name,
                    link: this.link,
                },
                update: (store, { data }) => {
                    try {
                        const videosListData = store.readQuery({ query: videosListQuery });
                        const video = data.update_videos.returning[0];
                        const index = videosListData.videos.findIndex(it => it.id == video.id);
                        if (index >= 0) {
                            videosListData.videos[index] = video;
                        }
                        else {
                            videosListData.videos.push(video);
                        }
                        store.writeQuery({ query: videosListQuery, data: videosListData });
                    }
                    catch (e) {
                        console.log('Failed to update cache after update_videos mutation');
                    }
                },
            },
            onTask: task => {
                this.submitTask = task;
                if (task.isSuccessful) {
                    this.$router.push({ name: 'videos_list' });
                }
            },
        });
    }
};
__decorate([
    Prop([String, Number])
], VideoEdit.prototype, "id", void 0);
VideoEdit = __decorate([
    Component({
        components: { VideoForm, TemplateContent }
    })
], VideoEdit);
export default VideoEdit;
